import { DEALS } from '../constants/dataTypes';
export const OBJECT_TYPE_ID_TO_NAME = {
  '0-1': 'CONTACT',
  '0-2': 'COMPANY',
  '0-3': 'DEAL',
  '0-5': 'TICKET'
};
export const OBJECT_TYPE_ID_TO_TABLE_GROUP = {
  '0-1': 'CONTACTS',
  '0-2': 'COMPANIES',
  '0-3': 'DEALS',
  '0-5': 'TICKETS'
};
export const EXCLUDED_COLUMNS = ['subject', '_inbounddbio.importid_'];
export const CRM_TO_BUILDER_PROPERTY = {
  [DEALS]: {
    relatesTo: 'associations.company',
    amount: 'amount_in_home_currency'
  }
};
export const CRM_VIEW_REPORT_CONTEXT = "IMPORTANT NOTE FOR IMPROVING INSIGHTFULNESS: To make this report as insightul as possible, be a bit more casual and approachable with your insights. Pay special attention to filters and the name of the report as they are really important context, reference them if you feel it would help, this will really help users trust the data. Casual, friendly, don't be afraid of colloquialisms and slang if it makes sense, this should match HubSpot's brand voice. Remember these are people who need help, they're not robots.";